import React from "react";

const LocalFileIcon = ({ fill }) => {
  return (
    <svg
      id="add_file_ic"
      xmlns="http://www.w3.org/2000/svg"
      width="17.192"
      height="19.999"
      viewBox="0 0 17.192 19.999"
    >
      <path
        id="Path_415"
        data-name="Path 415"
        d="M21.591,15.2H17.957A2.856,2.856,0,0,0,15.1,18.057V32.342A2.856,2.856,0,0,0,17.957,35.2H29.435a2.856,2.856,0,0,0,2.857-2.857V26Zm2.832,11.153a2.268,2.268,0,0,1-2.306-2.231v-5.89l8.045,8.12Z"
        transform="translate(-15.1 -15.2)"
        fill={fill ? fill : "#707070"}
      />
      <path
        id="Path_416"
        data-name="Path 416"
        d="M67.061,20.758H65.708v1.378a.476.476,0,0,1-.476.476h-.276a.476.476,0,0,1-.476-.476V20.758h-1.4a.476.476,0,0,1-.476-.476v-.276a.476.476,0,0,1,.476-.476h1.4V18.176a.476.476,0,0,1,.476-.476h.276a.476.476,0,0,1,.476.476V19.53h1.353a.476.476,0,0,1,.476.476v.276A.476.476,0,0,1,67.061,20.758Z"
        transform="translate(-50.696 -17.073)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};

export default LocalFileIcon;
